/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { EnrollCourseOptions, EnrollCourseStatus200, EnrollCourseStatus422 } from '../models/EnrollCourse'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { enrollCourse } from '../clients/axios/enrollCourse'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const enrollCourseMutationKey = () => [{ url: '/course/:course_id/enroll' }] as const

export function enrollCourseMutationOptions<TContext = unknown>(config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const mutationKey = enrollCourseMutationKey()
  return mutationOptions<EnrollCourseStatus200, ResponseErrorConfig<EnrollCourseStatus422>, EnrollCourseOptions, TContext>({
    mutationKey,
    mutationFn: async({ path }) => {
      return await enrollCourse({ ...config, path, throwOnError: true })
    },
  })
}

/**
 * @summary Enroll Course
 * {@link /course/:course_id/enroll}
 */
export function useEnrollCourse<TContext>(options: {
  mutation?: UseMutationOptions<EnrollCourseStatus200, ResponseErrorConfig<EnrollCourseStatus422>, EnrollCourseOptions, TContext> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>,
} = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? enrollCourseMutationKey()

  const baseOptions = enrollCourseMutationOptions(config) as UseMutationOptions<EnrollCourseStatus200, ResponseErrorConfig<EnrollCourseStatus422>, EnrollCourseOptions, TContext>

  return useMutation<EnrollCourseStatus200, ResponseErrorConfig<EnrollCourseStatus422>, EnrollCourseOptions, TContext>({
    ...baseOptions,
    mutationKey,
    ...mutationOptions,
  }, queryClient) as UseMutationResult<EnrollCourseStatus200, ResponseErrorConfig<EnrollCourseStatus422>, EnrollCourseOptions, TContext>
}
